import {gql} from '@apollo/client';

import {getRegistrySupportedOligoAwareTypesGraphQL} from 'constants/RegistryConstants';
import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';

import {GetTagSchemaIdsListing, GetTagSchemaIdsListingVariables} from './__generated/GetTagSchemaIdsListing';

export const GET_TAG_SCHEMA_IDS_LISTING_QUERY = gql`
  query GetTagSchemaIdsListing($searchInput: TagSchemaListingSearchInput, $limitOffsetInput: LimitOffsetInput)
  @skipAudit
  @engComponent(name: SCHEMAS) {
    tagSchemasListing(searchInput: $searchInput, limitOffsetInput: $limitOffsetInput) {
      tagSchemas {
        id
      }
      total
    }
  }
`;

interface UseTagSchemaIdsQueryArgs {
  registryId?: string | null;
}

export default function useTagSchemaIdsQuery({
  registryId = null,
}: UseTagSchemaIdsQueryArgs = {}): Set<string> | null {
  const tagSchemasResult = useBenchlingQuery<GetTagSchemaIdsListing, GetTagSchemaIdsListingVariables>(
    GET_TAG_SCHEMA_IDS_LISTING_QUERY,
    {
      variables: {
        searchInput: {
          registryId,
          oligoAwareFolderItemTypes: getRegistrySupportedOligoAwareTypesGraphQL(),
        },
      },
    }
  );

  if (tagSchemasResult.type !== QueryResultType.SUCCESS) {
    return null;
  } else {
    return new Set(tagSchemasResult.data.tagSchemasListing.tagSchemas.map((tagSchema) => tagSchema.id));
  }
}
